import './App.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import 'bootstrap/dist/css/bootstrap.min.css';
import React, {useState, useRef, useEffect } from 'react';
import jwt_decode from "jwt-decode";
import Header from "./components/Header";
import Login from './components/Login';
import Reservation from './components/Reservations';
import AdminDashboard from './components/AdminDashboard';
import Cookies from 'universal-cookie';

function App() {
  const cookies = new Cookies();
  const googlebuttonref = useRef();
  const [session, setSession] = useState();
  // Ruta actual (routing ligero sin react-router para no añadir dependencias).
  const [path, setPath] = useState(window.location.pathname);

  // Mantiene el estado de ruta sincronizado con el historial del navegador
  // (botones atrás/adelante).
  useEffect(() => {
    const onPop = () => setPath(window.location.pathname);
    window.addEventListener('popstate', onPop);
    return () => window.removeEventListener('popstate', onPop);
  }, []);

  // Navegación programática: cambia la URL sin recargar y actualiza el estado.
  const navigate = (to) => {
    if (window.location.pathname !== to) {
      window.history.pushState({}, '', to);
    }
    setPath(to);
  };

  // Solo se hace la verificacion del usuario al iniciar sesion
  // El seguimiento de inicio de sesión se hace con cookies
  useEffect(() => {
    (cookies.get('email_verified') === "true") ? setSession(true) : setSession(false);
    window.google.accounts.id.initialize({
      client_id: process.env.REACT_APP_CLIENT_ID_SALAS,
      callback: onGoogleSignIn,
      auto_select: false,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onGoogleSignIn = (user) => {
    let userGoogle = jwt_decode(user.credential);
    if(userGoogle.email_verified){
      console.log("usuario de google:", userGoogle);
      // El id_token de Google expira en ~1h. Las cookies se sincronizan con
      // ese tiempo para que la sesión del frontend expire junto con el token.
      const expiry = new Date(userGoogle.exp * 1000);
      const cookieOpts = { expires: expiry };
      cookies.set('given_name', userGoogle.name, cookieOpts);
      cookies.set('email', userGoogle.email, cookieOpts);
      cookies.set('picture', userGoogle.picture, cookieOpts);
      cookies.set('email_verified', userGoogle.email_verified, cookieOpts);
      cookies.set('id_token', user.credential, cookieOpts);
      if(userGoogle.email_verified === true){
        setSession(true);
      }
    }
  }

  useEffect(() => {
    if(session === false){
      cookies.remove('given_name');
      cookies.remove('email');
      cookies.remove('picture');
      cookies.remove('email_verified');
      cookies.remove('id_token');
      window.localStorage.removeItem('token');
      document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());
      document.body.classList.remove('modal-open');
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
      window.google.accounts.id.renderButton(googlebuttonref.current, {
        size: "medium",
        theme: "outline",
      });
    }
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [session])

  // Si no hay sesión, siempre mostramos el login.
  if (session !== true) {
    return (
      <div className="containerApp">
        <Header session={session}/>
        <Login googlebuttonref={googlebuttonref}/>
      </div>
    );
  }

  // Con sesión activa: enrutamos según el path.
  if (path === '/admin') {
    return (
      <div className="containerApp">
        <Header session={session}/>
        <AdminDashboard navigate={navigate} setSession={setSession} />
      </div>
    );
  }

  return (
    <div className="containerApp">
      <Header session={session}/>
      <Reservation
        session={session}
        setSession={setSession}
        userPicture={cookies.get("picture")}
        navigate={navigate}
      />
    </div>
  );
}
export default App;
